/* 
	在下方导入弹窗文件
	import xxx from 'xxx.vue'
	
	在DIALOG数组中注册组件
	DIALOG = [
		xxx
	]
	
	任意页面调用弹窗
	this.globalDialog(name, opt, resolve, cancel)
	可传入以下参数
	name: 弹窗name，对应弹窗文件中的name属性
	opt: {  传入弹窗的数据，包含两部分
		props: {...},  弹窗内props属性定义的变量值
		data: {...}  传入弹窗内open方法的数据
	}
	resolve:  确认回调函数，在弹窗内调用this.$emit('resolve')触发
	cancel: 取消回调函数，在弹窗内调用this.$emit('cancel')触发
	
	
	例如：
	this.globalDialog('staffSelector', {
		props: {
			multiple: true
		},
		data: {
			id: 1
		}
	}, this.aaa, this.bbb)
	
	等价于
	
	<staff-selector ref="staffSelector" :multiple="true" @resolve="aaa" @cancel="bbb"></staff-selector>
	this.$refs.staffSelector.open({
		id: 1
	});
 */

import router from '@/router';
import store from '@/store';

// 打印机设置
import printerConfig from "@/components/service/printer_config.vue"
// 选择打印模板
import exportTemplateSelector from "@/components/service/export_template_selector.vue"
// 系统业务日志
import workLogDetail from "@/pages/system/sys_work_logs_detail.vue"
// 导入Excel数据弹窗
import excelImport from "@/pages/system/import_excel_data.vue"
// 导入业务日志
import importLogDetail from "@/pages/system/import_work_logs_detail.vue"
// 模板管理
import templateManage from '@/components/service/template_manage.vue'
// 打印模板编辑
import printTemplateEdit from '@/components/service/print_template_edit.vue'
// 手机端视图配置
import appViewConfig from '@/components/service/app_view_config.vue'
import fieldConfig from '@/components/view/user_field_config.vue'
// 位置选择
import locationSelector from "@/components/service/location_selector.vue"


// 销售订单详情
import orderDetail from '@/pages/sales/order_detail.vue'
// 工单详情
import afterSaleOrderDetail from '@/pages/aftersale/aftersale_order_detail.vue'
// 工单编辑
import aftersaleOrderEdit from '@/pages/aftersale/aftersale_order_edit.vue'
// 工单成员管理
import aftersaleOrderMember from '@/pages/aftersale/aftersale_order_member.vue'
// 工单成本自资金详情
import estimatedCostDetail from '@/pages/aftersale/estimated_cost_detail.vue'
// 工单实际成本详情
import actualCostDetail from '@/pages/kanban/actual_cost_detail.vue'
// 售后申请单详情
import aftersaleApplyDetail from '@/pages/aftersale/aftersale_apply_detail.vue'
// 客户详情
import customerDetail from '@/pages/basic/customer_detail.vue'
// 产品详情
import productDetail from '@/pages/basic/product_detail.vue'
// 资产详情
import fixedAssetDetail from '@/pages/asset/fixed_asset_detail.vue'
// 资产领用单详情
import assetReceiveApplyDetail from '@/pages/asset/asset_receive_apply_detail.vue'
//外协招工详情
import outsourceRrecruitDetail from '@/pages/aftersale/out_sourcing_recruit_detail.vue'
//投诉建议详情
import complaintSuggestionDetail from '@/pages/basic/complaint_suggestion_detail.vue'
//费用报销详情
import expenseReimbursementDetail from '@/pages/finance/expense_reimbursement_detail.vue'
//请假单详情
import leaveApplicationDetail from '@/pages/basic/leave_application_detail.vue'
//加班申请详情
import overtimeApplicationDetail from '@/pages/basic/overtime_application_detail.vue'
//派单规则详情
import dispatchRuleDetail from '@/pages/basic/dispatch_rule_detail.vue'
//客户常用地址详情
import customerAddressDetail from '@/pages/basic/customer_address_detail.vue'
// 资产归还单详情
import assetReturnApplyDetail from '@/pages/asset/asset_return_apply_detail.vue'
// 维修记录详情
import assetRepairRecordDetail from '@/pages/asset/asset_repair_record_detail.vue'
// 维修记录列表弹窗
import assetRepairRecordListDialog from '@/pages/asset/asset_repair_record_dialog.vue'
// 借还记录列表弹窗
import assetBorrowRecordListDialog from '@/pages/asset/asset_borrow_record_dialog.vue'
// 转移记录列表弹窗
import assetTransferRecordListDialog from '@/pages/asset/asset_transfer_record_dialog.vue'
//自动派单日志详情
import afterSaleOrderDispatchLog from '@/pages/aftersale/aftersale_order_dispatch_log.vue'
//站内信详情
import messageDetail from '@/pages/system/message_detail.vue'
// 绩效统计-工程师工单明细
import engineerPerformanceDetail from '@/pages/kanban/engineer_performance_detail.vue'
// 绩效统计-安装产品平均工时明细
import engineerPerformanceProductDetail from '@/pages/kanban/engineer_performance_product_detail.vue'
//工程师-工单-工时明细
import orderWorkhoursDetail from '@/pages/aftersale/aftersale_order_workhours.vue'
// 上门服务记录单详情
import visitServiceDetail from '@/pages/aftersale/aftersale_visit_service_detail.vue'
// 上门服务记录单编辑
import visitServiceEdit from '@/pages/aftersale/aftersale_visit_service_edit.vue'
// MQ错误日志详情
import mqErrorLogDetail from '@/pages/system/mq_error_log_detail.vue'
// MQ补数据消息发送
import mqMessageSend from '@/pages/system/mq_message_send.vue'
// 修改售后位置（服务中）
import aftersaleOrderEditLocation from '@/pages/aftersale/aftersale_order_edit_location.vue'

const DIALOG = [
	printerConfig,
	exportTemplateSelector,
	workLogDetail,
	excelImport,
	importLogDetail,
	templateManage,
	printTemplateEdit,
	appViewConfig,
	fieldConfig,
	locationSelector,
	orderDetail,
	afterSaleOrderDetail,
	aftersaleOrderEdit,
	aftersaleOrderMember,
	estimatedCostDetail,
	actualCostDetail,
	aftersaleApplyDetail,
	customerDetail,
	productDetail,
	fixedAssetDetail,
	assetReceiveApplyDetail,
	outsourceRrecruitDetail,
	complaintSuggestionDetail,
	expenseReimbursementDetail,
	leaveApplicationDetail,
	overtimeApplicationDetail,
	dispatchRuleDetail,
	customerAddressDetail,
	assetReturnApplyDetail,
	assetRepairRecordDetail,
	assetRepairRecordListDialog,
	assetBorrowRecordListDialog,
	assetTransferRecordListDialog,
	afterSaleOrderDispatchLog,
	messageDetail,
	engineerPerformanceDetail,
	engineerPerformanceProductDetail,
	orderWorkhoursDetail,
	visitServiceDetail,
	visitServiceEdit,
	mqErrorLogDetail,
	mqMessageSend,
	aftersaleOrderEditLocation
]
const DIALOG_CACHE = {};
let zIndex = 1011;

export default {
	install: function(Vue) {
		function compareObjects(obj1, obj2) {
			const keys1 = Object.keys(obj1);
			const keys2 = Object.keys(obj2);

			if (keys1.length !== keys2.length) {
				return false;
			}

			for (let key of keys1) {
				if (!keys2.includes(key) || obj1[key] !== obj2[key]) {
					return false;
				}
			}
			return true;
		}
		
		Vue.prototype.globalDialog = function(name, opt = {}, resolve, cancel) {
			if (typeof opt == 'function') {
				cancel = resolve;
				resolve = opt;
				opt = {};
			}
			
			if (DIALOG_CACHE[name] && !compareObjects(opt.props || {}, DIALOG_CACHE[name].props || {})) {
				DIALOG_CACHE[name].vm.$destroy();
			}
			
			if (!DIALOG_CACHE[name]) {
				DIALOG_CACHE[name] = {props: opt.props};
				let comp = DIALOG.find(comp => comp.name == name);
				if (!comp) return;
				let constructor = Vue.extend(comp);
				DIALOG_CACHE[name].vm = new constructor({
					router,
					store,
					el: document.createElement('div'),
					propsData: opt.props,
					beforeDestroy() {
						delete DIALOG_CACHE[name];
						this.$el.remove();
					}
				});
				document.body.appendChild(DIALOG_CACHE[name].vm.$el);
				DIALOG_CACHE[name].vm.$el.style.position = 'relative';
			}
			
			DIALOG_CACHE[name].vm.$el.style.zIndex = zIndex++;
			DIALOG_CACHE[name].vm.open(opt.data);
			
			let events = {resolve, cancel};
			for (let event in events) {
				DIALOG_CACHE[name].vm.$off(event);
				events[event] && DIALOG_CACHE[name].vm.$on(event, (...params) => {
					events[event].apply(this, params);
				});
			}

			return DIALOG_CACHE[name].vm;
		}

		Vue.prototype.globalDialogDestroy = function() {
			for (let name in DIALOG_CACHE) {
				DIALOG_CACHE[name].vm.$destroy();
			}
		}
	}
}